import { Methods } from "@newview/infrastructure";
import { NewviewOaBaseApi } from "./NewviewOaBaseApi";


export class ArchiveOutgoingApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'archive-outgoing'
    }


    /**
     * 查询发文管理列表
     * @param CurrentPageIndex 
     * @param PageSize 
     * @param Params 
     * @returns 
     */
    public getArchiveOutgoingPage(CurrentPageIndex,PageSize,Params){
        return this.send(Params,"getArchiveOutgoingPage?CurrentPageIndex="+CurrentPageIndex+"&PageSize="+PageSize,this.Methods.GET)
    }

    public getInternalReceiptPage(CurrentPageIndex,PageSize,Params){
        return this.send(Params,"getInternalReceiptPage?CurrentPageIndex="+CurrentPageIndex+"&PageSize="+PageSize,this.Methods.GET)
    }

    public getNBList(CurrentPageIndex,PageSize,Params){
        return this.send(Params,"getNBList?CurrentPageIndex="+CurrentPageIndex+"&PageSize="+PageSize,this.Methods.GET)
    }


    /**
     * 导出
     * @returns 
     */
  public excel(params) {
    return this.download(params, "excel")
  }

    /**
     * 导出
     * @returns
     */
    public receiptExcel(params) {
        return this.download(params, "receiptExcel")
    }


   




}